import { render, staticRenderFns } from "./AdminSurveyDetail.vue?vue&type=template&id=067ef3a6&scoped=true&"
import script from "./AdminSurveyDetail.vue?vue&type=script&lang=js&"
export * from "./AdminSurveyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067ef3a6",
  null
  
)

export default component.exports